// Iconos de línea del menú lateral (sistema de diseño Homelan).
//
// Las rutas siguen trayendo `iconsrc` (los PNG de colores) e `icon`
// (FontAwesome) para otras pantallas que los usan; el menú lateral busca
// primero aquí por la URL de la ruta, o por el nombre en los grupos sin URL.
import {
  ArrowLeftRight,
  Award,
  Building2,
  CalendarRange,
  ChartColumn,
  CirclePlus,
  CircleParking,
  CreditCard,
  FileChartColumn,
  House,
  IdCard,
  Inbox,
  KeyRound,
  Landmark,
  LayoutGrid,
  LifeBuoy,
  Megaphone,
  MessageSquareText,
  Newspaper,
  Percent,
  PiggyBank,
  Settings,
  ShieldCheck,
  Store,
  Trees,
  Truck,
  UserCheck,
  Users,
  UserX,
  Vote,
  Wallet,
} from 'lucide-react';

const byPath = {
  '/dashboard/app': House,
  '/dashboard/condominiums': Building2,
  '/dashboard/banks': Landmark,
  '/dashboard/exchange': ArrowLeftRight,
  '/dashboard/periods': CalendarRange,
  '/dashboard/finance': Wallet,
  '/dashboard/my/finance': Wallet,
  '/dashboard/aliquots': Percent,
  '/dashboard/funds': PiggyBank,
  '/dashboard/properties': Building2,
  '/dashboard/providers': Truck,
  '/dashboard/security': ShieldCheck,
  '/dashboard/visitors': UserCheck,
  '/dashboard/areas': Trees,
  '/dashboard/parking': CircleParking,
  '/dashboard/parking/my/stalls': CircleParking,
  '/dashboard/surveys': Vote,
  '/dashboard/rewards': Award,
  '/dashboard/complaints': MessageSquareText,
  '/dashboard/config': Settings,
  '/dashboard/support': LifeBuoy,
  '/dashboard/feed': Newspaper,
  '/dashboard/release': Megaphone,
  '/dashboard/renter': Users,
  '/dashboard/marketplace': Store,
  '/errors': FileChartColumn,
  '/root': House,
  '/root/condominiums': Building2,
  '/root/indicators': ChartColumn,
  '/root/paymethods': CreditCard,
  '/root/support': LifeBuoy,
  '/root/lead': Users,
  '/root/account-deletion': UserX,
  '/root/rewards': Award,
  '/root/marketplace': Store,
  '/root/exchange': ArrowLeftRight,
  '/root/config': Settings,
  '/provider': Store,
  '/provider/services/create': CirclePlus,
  '/provider/requests': Inbox,
  '/provider/profile': IdCard,
};

const byName = {
  Administración: LayoutGrid,
  Condominio: Building2,
  Reportes: FileChartColumn,
  Soporte: LifeBuoy,
  'Usuarios autorizados': KeyRound,
};

export const getNavIcon = (route) => byPath[route.to] || byName[route.name] || null;
